import { notImplemented } from './Debug';
export var ClipboardService = {
    setClipboard: function (data) { notImplemented('setClipboard'); }
};
